"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Icon_1 = require("../Icon");
var react_dom_1 = require("react-dom");
var uniqueId_1 = tslib_1.__importDefault(require("lodash/uniqueId"));
var Background_1 = tslib_1.__importDefault(require("./Background"));
var StyledModal_1 = require("./StyledModal");
var Text_1 = require("../Text");
var icons_1 = require("../../icons");
var ModalCloseButton = styled_components_1.default(Icon_1.IconButton)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  right: 0;\n"], ["\n  position: absolute;\n  right: 0;\n"])));
var Modal = function (_a) {
    var title = _a.title, _b = _a.titleStyles, titleStyles = _b === void 0 ? {
        size: 'large',
        weight: 'bold'
    } : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, onClose = _a.onClose, isOpen = _a.isOpen, children = _a.children, _d = _a.clickAwayClose, clickAwayClose = _d === void 0 ? true : _d, _e = _a.fullscreen, fullscreen = _e === void 0 ? false : _e, _f = _a.hideTitleBar, hideTitleBar = _f === void 0 ? false : _f, _g = _a.hideFooterBar, hideFooterBar = _g === void 0 ? false : _g, footer = _a.footer, modalHeight = _a.modalHeight;
    var modalId = uniqueId_1.default('modal');
    return isOpen
        ? react_dom_1.createPortal(react_1.default.createElement(Background_1.default, { clickAwayClose: clickAwayClose, onClose: onClose },
            react_1.default.createElement(StyledModal_1.ModalContent, { height: modalHeight, size: size, fullscreen: fullscreen, role: "dialog", "aria-modal": "true", "aria-labelledby": modalId + "-title", "data-testid": "modal-content" },
                hideTitleBar ? null : (react_1.default.createElement(StyledModal_1.ModalTitle, null,
                    react_1.default.createElement(Text_1.Text, tslib_1.__assign({}, titleStyles, { id: modalId + "-title" }), title || react_1.default.createElement(react_1.default.Fragment, null, "\u00A0")),
                    react_1.default.createElement(ModalCloseButton, { label: "close", onClick: onClose, "data-testid": "close-btn", iconProps: {
                            id: 'close',
                            icon: icons_1.Clear,
                            width: '1.2em',
                            height: '1.2em'
                        } }))),
                react_1.default.createElement(StyledModal_1.ModalBody, null, children),
                hideFooterBar ? null : react_1.default.createElement(StyledModal_1.ModalFooter, null, footer))), document.body)
        : null;
};
exports.default = Modal;
var templateObject_1;
//# sourceMappingURL=Modal.js.map